import { Component,ElementRef,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController,Slides,Events,Platform,AlertController } from 'ionic-angular';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'
import { MenuController } from 'ionic-angular';
import { Storagehelper } from '../../providers/storagehelper'
import { Commontask } from '../../providers/commontask'

declare var document;
import { Filetransfer} from '../../providers/filetransfer'
import { SocialSharing } from '@ionic-native/social-sharing';

/**
 * Generated class for the PageSlider page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-page-slider',
  templateUrl: 'page-slider.html',
})
export class PageSlider extends Commontask {
	@ViewChild(Slides) slides: Slides;
 	@ViewChild('ioncontent') ioncontent: ElementRef;
 	@ViewChild('detailPage') dataContainer: ElementRef;
	private pageid;
	public pageDetail;
	public bgImage;
	private loading;
	public slideIndex;
	public removebckbutton;
	public isFavorite;
	public bckclass;
	constructor(public navCtrl: NavController,public event:Events, public navParams: NavParams,public storage: Storagehelper,public loader:LoadingController,public menuctrl:MenuController,public sanitizer:DomSanitizer,public filetransfer:Filetransfer,public platform:Platform,public socialShare:SocialSharing,public alertCtrl:AlertController) {
		super(menuctrl,event,platform,socialShare,alertCtrl);
		this.pageDetail={PageTitle:"",slidertasks:[],PageContent:"",bgImageUrl:"",localImageFile:"assets/images/c.png"};
		this.pageid=navParams.get('pageID');
		this.removebckbutton=navParams.get('removebckbutton');
		this.getPageDetail();
	  	this.loading=this.loader.create({
	      spinner:"ios",
	      cssClass:"dreamLoader"
	    });
	    this.isFavorite=false;
	    this.bckclass="";
	    this.loading.present();
	    this.slideIndex=0;
	    this.bgImage = sanitizer.bypassSecurityTrustStyle('url(http://109.74.12.180/Dream/Uploads/Images/08253740996870014_backgroun`d_003(1).png)');
		this.getCategoryByCategoryID(storage,navParams);
	    // this.slides.pager=true;
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad PageSlider');
	}


	changeBackground(){

		console.log("changing background");
		var image=this.sanitizer.bypassSecurityTrustStyle('url('+this.pageDetail.localImageFile+')');
		return 'url('+image+')';
		// return { 'background-image': this.pageDetail.localImageFile };
	}

	slidePrev(){
		console.log("Previous slide");
		this.slides.slidePrev();
		this.slideIndex=this.slides.getActiveIndex();
	}

	slideNext(){
		console.log("Next slide");
		this.slides.slideNext();
		this.slideIndex=this.slides.getActiveIndex();
	}

	ionViewDidEnter(){
		this.checkFavorite();
	}

	slideChanged(){
		
		this.slideIndex=this.slides.getActiveIndex();
	}

	getPageDetail(){

		this.storage.queryStorage('pagelist','Id',this.pageid).then((data)=>{
			if(data.length>0){
				this.pageDetail=data[0];
				this.checkFavorite();
				if(this.pageDetail.pagelinks.length>0){
					 this.pageDetail.pagelinks.map((e,i)=>{
					 	e.categoryid=this.navParams.get("categoryID");
					 })
				}
		     		
	     		if(this.pageDetail.backgroundType==1)	{	
		     		if(this.pageDetail.bgImageUrl!="")	{	
		     			var localCheck=this.checkIfBackgroundStatic(this.pageDetail.bgImageUrl);
		     			if(localCheck!=false){
							this.loading.dismiss();
			     			// this.pageDetail.localImageFile=localurl;
			     			//Using javascript to set page background
			     			// document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('../assets/images/"+localCheck+".png')"
				     		this.bckclass=localCheck;
		     			}else{

			     			this.filetransfer.checkFileInLocal(this.pageDetail.bgImageUrl,"images").then((status)=>{
			     				if(status=="false"){

			     					var localCheck=this.checkIfBackgroundStatic(this.pageDetail.bgImageUrl);
		     						if(localCheck!=false){
										this.loading.dismiss();
						     			// this.pageDetail.localImageFile=localurl;
						     			//Using javascript to set page background
						     			document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('../assets/images/"+localCheck+".png')"
							     		
					     			}else{
					     					this.filetransfer.saveFileLocally(this.pageDetail.bgImageUrl,"images").then((localurl)=>{
								     			this.loading.dismiss();
								     			this.pageDetail.localImageFile=localurl;
								     			//Using javascript to set page background
								     			document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.pageDetail.localImageFile+"')"
								     		
								     		},(err)=>{
													this.loading.dismiss();
								     			if(err=="browser"){

								     			}
								     		});
								     		this.pageDetail.localImageFile = this.pageDetail.bgImageUrl;
								     		document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.pageDetail.localImageFile+"')"
								     	}
						     		
			     				}else{
			     					this.pageDetail.localImageFile = status;
						     		document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.pageDetail.localImageFile+"')"
			     				}
			     				this.loading.dismiss();
			     			},(err)=>{
			     				this.loading.dismiss();
					     		this.pageDetail.localImageFile = this.pageDetail.bgImageUrl;
					     		document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.pageDetail.localImageFile+"')"
			     			})
		     			}
		     		}else{

								this.loading.dismiss();
		     		}
	     		}else{
	     			this.loading.dismiss();
	     			document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundColor="#"+this.pageDetail.backgroundColor;
				     				document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="unset";
	     		}

			}
		})

	}


    private checkFavorite(){
    	this.storage.queryStorage('favoriteTasks','Id',this.pageDetail.Id).then((data)=>{
    		if(data!=null && data.length>0){
    			this.isFavorite=true;
    		}
    	})
    }


    public makeTaskFav(){
    	// this.storage.setStorageItem('favorite')
    	if(!this.isFavorite){
	    	this.storage.deleteItem('favoriteTasks','Id',this.pageDetail.Id).then(()=>{
	    		this.pageDetail.categoryid=this.categoryDetail.category_id;
	    		this.storage.addNewItem('favoriteTasks','FavoriteId',this.pageDetail).then(()=>{
	    			this.isFavorite=true;
				  		let alert=this.alertCtrl.create({
				  			title:this.alertTitle,
				  			message:'Sparat i menyn under favoriter',
				  			buttons:[{
				  				text:'OK',
				  				role:'cancel'
				  			}]
				  		})
				  		alert.present();
    				this.event.publish("app:loadFavoriteItems");
	    		})
	    			
	    	})
    	}else{
    		this.storage.deleteItem('favoriteTasks','Id',this.pageDetail.Id).then(()=>{
	    			this.isFavorite=false;
				  		let alert=this.alertCtrl.create({
				  			title:this.alertTitle,
				  			message:'Borttaget som favorit i menyn ',
				  			buttons:[{
				  				text:'OK',
				  				role:'cancel'
				  			}]
				  		})
				  		alert.present();
    				this.event.publish("app:loadFavoriteItems");
	    			
	    	})
    	}
    }
}



// WEBPACK FOOTER //
// ./src/pages/page-slider/page-slider.ts